// AppLoading.js
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import HomeplusBigLogo from '../../asset/image/homeplus.svg';

const LogoWidth = 360;
const LogoRightMargin = 40;
const LoginBoxWidth = 520;

const OutterBox = styled(Box)({
    display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh',
});

const InnerBox = styled(Box)({
    display: 'inline-flex', width: (LoginBoxWidth + LogoWidth + LogoRightMargin), marginBottom: 100,
});

const LogoBox = styled(Box)({flexGrow: 1, opacity: 0.05});

const LoadingBox = styled(Box)({
    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
    textAlign:'center', fontSize: 24, fontWeight: 'bold', color: '#aac',
    paddingTop: 20,
});

const TopText = styled(Box)({
    fontSize: 28, fontWeight: 'bold', fontFamily: 'Times New Roman', fontStyle: 'italic',
});


export default function AppLoading({
    messages
}) {

    const lines = messages ? messages : [
        "홈플러스 TOP 시스템입니다.",
        "로그인 상태를 확인 중입니다.",
        "잠시만 기다려 주세요..."
    ];

    return(
        <OutterBox>
            <InnerBox>
                <LogoBox>
                    <img src={HomeplusBigLogo} alt="Homeplus" width={LogoWidth}
                        style={{marginRight: LogoRightMargin}}
                    />
                    <TopText>
                        <span style={{color:"red"}}>T</span>ransport &nbsp;
                        <span style={{color:"orange"}}>O</span>peration &nbsp;
                        <span style={{color:"green"}}>P</span>rogram
                    </TopText>
                </LogoBox>
                <LoadingBox>
                    {
                        lines.map((line, index) => {
                            return (
                                <p key={index}>{line}</p>
                            );
                        })
                    }
                </LoadingBox>
            </InnerBox>
        </OutterBox>
    );
}